export const LOCALSTORAGE_DARK_MODE = "LOCALSTORAGE_DARK_MODE";
